import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Footer from "../../core/common/Footer";
import handleClearError from "../../core/methods/handleClearError";
import { ErrorType } from "../../types/common-type";
import SearchableSelect from "../../core/common/SearchableSelect";
import {
  clientOptions,
  programOption,
  sbuOptions,
} from "../../core/data/js/common-data";
import ReportsMaster from "./reports-and-tracker/ReportsMaster";
import Tracker from "./reports-and-tracker/Tracker";

const ReportAndTracker = () => {
  const [tabSwitch, setTabSwitch] = useState("reports");

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Reports & Trackers</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.superAdminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Account Activation</li>
                <li className="breadcrumb-item active">Reports & Trackers</li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>

        <div className="d-flex justify-content-start gap-2 align-items-center mt-3">
          <button
            className={`btn ${tabSwitch === "reports" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTabSwitch("reports")}
          >
            Reports
          </button>
          <button
            className={`btn ${tabSwitch === "tracker" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTabSwitch("tracker")}
          >
            Tracker
          </button>
        </div>

        {tabSwitch === "reports" && <ReportsMaster />}
        {tabSwitch === "tracker" && <Tracker />}
      </div>

      <Footer />
    </div>
  );
};

export default ReportAndTracker;
